export enum Role {
  NOT_MEMBER = 1,
  MEMBER = 2,
  PAID_MEMBER = 3,
  REAL_ESTATE = 4,
  CONSULTANT = 5,
  ADMIN = 6,
  DESIGN = 7,
  INSIDE_SALES = 8
}
